(() => {
    'use strict';

    const navTree = (navTreeElement) => {
        if (navTreeElement?.tagName === 'LI' || navTreeElement?.tagName === 'UL') {
            collapsible(navTreeElement);
        }
    };

    const collapsible = element => {
        [...element.getElementsByTagName('li')].map(liElement => {
            collapsibleAll(liElement);
        });
    };

    const clickLinkEventHandler = e => {
        e.preventDefault();
        const opener = e.currentTarget.parentElement?.querySelector(':scope > span.opener');
        if (opener?.classList.contains('closed')) {
            expand(e.currentTarget);

            // If there's a real target to this menu item link, then allow it to be
            // clicked to go to that page, now that the menu has been expanded.
            if (e.currentTarget.getAttribute('href') !== '#' && e.currentTarget.getAttribute('href') !==  null) {
                e.currentTarget.removeEventListener('click', clickLinkEventHandler)
            }
        } else {
            collapse(e.currentTarget);
        }
    }

    const clickOpenerEventHandler = e => {
        if (e.currentTarget.classList.contains('closed')) {
            expand(e.currentTarget);
        } else {
            collapse(e.currentTarget);
        }
    }

    const collapsibleAll = liElement => {
        const childListUl = liElement?.querySelectorAll(':scope > ul');
        if (childListUl.length > 0) {
            [...childListUl].map(childUl => {
                childUl.style.display = 'none';
            });
            liElement.insertAdjacentHTML('afterbegin', '<span class="opener closed"><span class="tree-icon-closed halflings halflings-icon-chevron-thin-right"><i class="icon-expand-alt"></i></span><span class="tree-icon-opened halflings halflings-icon-chevron-thin-down"><i class="icon-collapse-alt"></i></span></span>');

            const aElement = liElement?.querySelector(':scope > a');
            aElement.addEventListener('click', clickLinkEventHandler);

            const spanElement = liElement?.querySelector(':scope > span.opener');
            spanElement.addEventListener('click', clickOpenerEventHandler);
        }
    };

    const expand = opener => {
        opener.classList.remove('closed');
        opener.classList.add('opened');
        $(opener.parentElement).children('ul').first().slideDown('fast');
    };

    const collapse = opener => {
        opener.classList.remove('opened');
        opener.classList.add('closed');
        $(opener.parentElement).children('ul').first().slideUp('fast');
    };

    [...document.querySelectorAll('ul[data-setu-toggle=nav-tree]')].map(navTreeElement => {
        navTree(navTreeElement);
    });
})();
